import { 
    Card, 
    CardContent, 
    Chip, 
    Grid, 
    Stack, 
    Typography, 
    Box,
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Badge,
    Paper,
    Tabs,
    Tab,
    Tooltip
} from "@mui/material";
import * as React from 'react'
import PageTitle from "../../../components/PageTitle";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsIcon from "@mui/icons-material/Sms";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import StorefrontIcon from "@mui/icons-material/Storefront";
import BusinessIcon from "@mui/icons-material/Business";
import InfoIcon from "@mui/icons-material/Info";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";

function NotificationsSubscriptions({ data }) {
    console.log(data, "data")
    
    const [selectedTab, setSelectedTab] = React.useState(0);
    
    const d2cSubscriptions = data?.alertSubscription?.subscriptions || {};
    const b2bSubscriptions = data?.alertSubscriptionB2B?.subscriptions || {};
    // B2C reverse (RVP) shipments have their own subscription, separate from forward D2C
    const rvpSubscriptions = data?.alertSubscriptionRvp?.subscriptions || {};

    const d2cEmailList = d2cSubscriptions.EMAIL || [];
    const d2cWhatsappList = d2cSubscriptions.WHATSAPP || [];
    const d2cSmsList = d2cSubscriptions.SMS || [];

    const b2bEmailList = b2bSubscriptions.EMAIL || [];
    const b2bWhatsappList = b2bSubscriptions.WHATSAPP || [];
    const b2bSmsList = b2bSubscriptions.SMS || [];

    const rvpEmailList = rvpSubscriptions.EMAIL || [];
    const rvpWhatsappList = rvpSubscriptions.WHATSAPP || [];
    const rvpSmsList = rvpSubscriptions.SMS || [];

    const d2cTotalSubscriptions = d2cEmailList.length + d2cWhatsappList.length + d2cSmsList.length;
    const b2bTotalSubscriptions = b2bEmailList.length + b2bWhatsappList.length + b2bSmsList.length;
    const rvpTotalSubscriptions = rvpEmailList.length + rvpWhatsappList.length + rvpSmsList.length;
    const totalSubscriptions = d2cTotalSubscriptions + b2bTotalSubscriptions + rvpTotalSubscriptions;

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const getNotificationDescription = (status) => {
        const descriptions = {
            "PLACED": "When a shipment is created on Proship platform",
            "PICKED": "When a shipment is picked up by courier partner from origin",
            "LIVE": "When the shipment moves in transit between orogin and destination",
            "OFD": "When shipment is out for delivery to the customer",
            "OUT_FOR_DELIVERY": "When shipment is out for delivery to the customer",
            "DELIVERED": "When shipment is successfully delivered to the customer",
            "RTO": "When shipment is being marked as RTO",
            "DELAY": "When there's an exception or delay in shipment movement",
            "NDR": "When delivery attempt fails and NDR is generated",
            "RVP_PICKED": "When a return (RVP) shipment is picked up from the customer"
        };
        return descriptions[status] || "Notification for shipment status updates";
    };

    const getNotificationIcon = (status) => {
        const icons = {
            "PLACED": <CheckCircleIcon color="success" fontSize="small" />,
            "PICKED": <LocalShippingIcon color="primary" fontSize="small" />,
            "LIVE": <LocalShippingIcon color="warning" fontSize="small" />,
            "OFD": <LocalShippingIcon color="info" fontSize="small" />,
            "OUT_FOR_DELIVERY": <LocalShippingIcon color="info" fontSize="small" />,
            "DELIVERED": <CheckCircleIcon color="success" fontSize="small" />,
            "RTO": <ErrorIcon color="error" fontSize="small" />,
            "EXCEPTION": <ErrorIcon color="warning" fontSize="small" />,
            "DELAY": <ErrorIcon color="warning" fontSize="small" />,
            "LOST": <ErrorIcon color="error" fontSize="small" />,
            "DAMAGED": <ErrorIcon color="error" fontSize="small" />,
            "NDR": <ErrorIcon color="warning" fontSize="small" />,
            "RVP_PICKED": <AssignmentReturnIcon color="primary" fontSize="small" />
        };
        return icons[status] || <NotificationsIcon color="action" fontSize="small" />;
    };

    const NotificationSection = ({ icon, title, items, color, emptyMessage }) => (
        <Paper 
            elevation={1} 
            sx={{ 
                p: 3, 
                borderRadius: 2,
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    elevation: 3,
                    transform: 'translateY(-2px)'
                }
            }}
        >
            <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar 
                        sx={{ 
                            bgcolor: `${color}.light`, 
                            color: `${color}.main`,
                            width: 48,
                            height: 48
                        }}
                    >
                        {icon}
                    </Avatar>
                    <Box flex={1}>
                        <Typography variant="h6" fontWeight={600}>
                            {title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {items.length} subscription{items.length !== 1 ? 's' : ''}
                        </Typography>
                    </Box>
                    <Badge 
                        badgeContent={items.length} 
                        color={items.length > 0 ? color : "default"}
                        max={99}
                    >
                        <NotificationsIcon color={items.length > 0 ? color : "disabled"} />
                    </Badge>
                </Stack>
                
                {items.length > 0 ? (
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                        {items.map((item, index) => (
                            <Chip 
                                key={index} 
                                label={item} 
                                color={color}
                                variant="filled"
                                size="small"
                                sx={{
                                    borderRadius: '16px',
                                    fontWeight: 500,
                                    '& .MuiChip-label': {
                                        px: 1.5
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                ) : (
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1,
                            p: 2,
                            backgroundColor: 'grey.50',
                            borderRadius: 1,
                            border: '1px dashed',
                            borderColor: 'grey.300'
                        }}
                    >
                        <NotificationsOffIcon color="disabled" fontSize="small" />
                        <Typography variant="body2" color="text.secondary">
                            {emptyMessage}
                        </Typography>
                    </Box>
                )}
            </Stack>
        </Paper>
    );

    const SubscriptionListView = ({ emailList, whatsappList, smsList, type }) => (
        <Card sx={{ mt: 3 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom fontWeight={600}>
                    All {type} Notification Channels
                </Typography>
                <List>
                    {emailList.map((status, index) => (
                        <ListItem key={`${type}-email-${index}`} divider>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: 'primary.light' }}>
                                    <EmailIcon color="primary" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText 
                                primary={
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        {getNotificationIcon(status)}
                                        <Typography fontWeight={500}>{status}</Typography>
                                    </Stack>
                                }
                                secondary={getNotificationDescription(status)}
                            />
                            <Chip label="Email" color="primary" size="small" />
                        </ListItem>
                    ))}
                    
                    {whatsappList.map((status, index) => (
                        <ListItem key={`${type}-whatsapp-${index}`} divider>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: 'success.light' }}>
                                    <WhatsAppIcon color="success" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText 
                                primary={
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        {getNotificationIcon(status)}
                                        <Typography fontWeight={500}>{status}</Typography>
                                    </Stack>
                                }
                                secondary={getNotificationDescription(status)}
                            />
                            <Chip label="WhatsApp" color="success" size="small" />
                        </ListItem>
                    ))}
                    
                    {smsList.map((status, index) => (
                        <ListItem key={`${type}-sms-${index}`} divider={index < smsList.length - 1 || emailList.length > 0 || whatsappList.length > 0}>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: 'warning.light' }}>
                                    <SmsIcon color="warning" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText 
                                primary={
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        {getNotificationIcon(status)}
                                        <Typography fontWeight={500}>{status}</Typography>
                                    </Stack>
                                }
                                secondary={getNotificationDescription(status)}
                            />
                            <Chip label="SMS" color="warning" size="small" />
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    );

    return (
        <Box>
            <PageTitle>
                Notification Subscriptions {data?.name ? " / " + data?.name : ""}
            </PageTitle>
            
            {/* Summary Cards */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={3}>
                    <Card sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                        <CardContent>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                                    <NotificationsIcon sx={{ color: 'white', fontSize: 24 }} />
                                </Avatar>
                                <Box>
                                    <Typography variant="h4" color="white" fontWeight={700}>
                                        {totalSubscriptions}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                        Total Subscriptions
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
                
                <Grid item xs={12} md={3}>
                    <Card sx={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
                        <CardContent>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                                    <StorefrontIcon sx={{ color: 'white', fontSize: 24 }} />
                                </Avatar>
                                <Box>
                                    <Typography variant="h4" color="white" fontWeight={700}>
                                        {d2cTotalSubscriptions}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                        B2C Forward Subscriptions
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={3}>
                    <Card sx={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' }}>
                        <CardContent>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                                    <AssignmentReturnIcon sx={{ color: 'white', fontSize: 24 }} />
                                </Avatar>
                                <Box>
                                    <Typography variant="h4" color="white" fontWeight={700}>
                                        {rvpTotalSubscriptions}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                        B2C RVP Subscriptions
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={3}>
                    <Card sx={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
                        <CardContent>
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                                    <BusinessIcon sx={{ color: 'white', fontSize: 24 }} />
                                </Avatar>
                                <Box>
                                    <Typography variant="h4" color="white" fontWeight={700}>
                                        {b2bTotalSubscriptions}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
                                        B2B Subscriptions
                                    </Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Tabs for B2C Forward, B2C RVP and B2B */}
            <Card>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={selectedTab} onChange={handleTabChange} aria-label="notification tabs">
                        <Tab
                            label={
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <StorefrontIcon />
                                    <span>B2C Forward Notifications</span>
                                    <Chip label={d2cTotalSubscriptions} size="small" color="primary" />
                                </Stack>
                            }
                        />
                        <Tab
                            label={
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <AssignmentReturnIcon />
                                    <span>B2C RVP Notifications</span>
                                    <Chip label={rvpTotalSubscriptions} size="small" color="success" />
                                </Stack>
                            }
                        />
                        <Tab
                            label={
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <BusinessIcon />
                                    <span>B2B Notifications</span>
                                    <Chip label={b2bTotalSubscriptions} size="small" color="secondary" />
                                </Stack>
                            }
                        />
                    </Tabs>
                </Box>
                
                {/* D2C Tab Content */}
                {selectedTab === 0 && (
                    <Box sx={{ p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <Typography variant="h6" fontWeight={600}>
                                B2C Forward Notification Channels
                            </Typography>
                            <Tooltip title="These notifications are sent for forward D2C shipments when status changes occur">
                                <InfoIcon color="action" fontSize="small" />
                            </Tooltip>
                        </Stack>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<EmailIcon />}
                                    title="Email Notifications"
                                    items={d2cEmailList}
                                    color="primary"
                                    emptyMessage="No D2C email subscriptions configured"
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<WhatsAppIcon />}
                                    title="WhatsApp Notifications"
                                    items={d2cWhatsappList}
                                    color="success"
                                    emptyMessage="No D2C WhatsApp subscriptions configured"
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<SmsIcon />}
                                    title="SMS Notifications"
                                    items={d2cSmsList}
                                    color="warning"
                                    emptyMessage="No D2C SMS subscriptions configured"
                                />
                            </Grid>
                        </Grid>
                        
                        {d2cTotalSubscriptions > 0 && (
                            <SubscriptionListView 
                                emailList={d2cEmailList}
                                whatsappList={d2cWhatsappList}
                                smsList={d2cSmsList}
                                type="D2C"
                            />
                        )}
                    </Box>
                )}
                
                {/* B2C RVP Tab Content */}
                {selectedTab === 1 && (
                    <Box sx={{ p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <Typography variant="h6" fontWeight={600}>
                                B2C RVP Notification Channels
                            </Typography>
                            <Tooltip title="These notifications are sent to the end customer for reverse pickup (RVP) shipments when status changes occur">
                                <InfoIcon color="action" fontSize="small" />
                            </Tooltip>
                        </Stack>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<EmailIcon />}
                                    title="Email Notifications"
                                    items={rvpEmailList}
                                    color="primary"
                                    emptyMessage="No RVP email subscriptions configured"
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<WhatsAppIcon />}
                                    title="WhatsApp Notifications"
                                    items={rvpWhatsappList}
                                    color="success"
                                    emptyMessage="No RVP WhatsApp subscriptions configured"
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<SmsIcon />}
                                    title="SMS Notifications"
                                    items={rvpSmsList}
                                    color="warning"
                                    emptyMessage="No RVP SMS subscriptions configured"
                                />
                            </Grid>
                        </Grid>

                        {rvpTotalSubscriptions > 0 && (
                            <SubscriptionListView
                                emailList={rvpEmailList}
                                whatsappList={rvpWhatsappList}
                                smsList={rvpSmsList}
                                type="RVP"
                            />
                        )}
                    </Box>
                )}

                {/* B2B Tab Content */}
                {selectedTab === 2 && (
                    <Box sx={{ p: 3 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <Typography variant="h6" fontWeight={600}>
                                Business-to-Business (B2B) Notification Channels
                            </Typography>
                            <Tooltip title="These notifications are sent for B2B shipments when status changes occur">
                                <InfoIcon color="action" fontSize="small" />
                            </Tooltip>
                        </Stack>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<EmailIcon />}
                                    title="Email Notifications"
                                    items={b2bEmailList}
                                    color="primary"
                                    emptyMessage="No B2B email subscriptions configured"
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<WhatsAppIcon />}
                                    title="WhatsApp Notifications"
                                    items={b2bWhatsappList}
                                    color="success"
                                    emptyMessage="No B2B WhatsApp subscriptions configured"
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <NotificationSection
                                    icon={<SmsIcon />}
                                    title="SMS Notifications"
                                    items={b2bSmsList}
                                    color="warning"
                                    emptyMessage="No B2B SMS subscriptions configured"
                                />
                            </Grid>
                        </Grid>
                        
                        {b2bTotalSubscriptions > 0 && (
                            <SubscriptionListView 
                                emailList={b2bEmailList}
                                whatsappList={b2bWhatsappList}
                                smsList={b2bSmsList}
                                type="B2B"
                            />
                        )}
                    </Box>
                )}
            </Card>
        </Box>
    );
}

export default NotificationsSubscriptions;
